import React from 'react';

import './Blocked.billing.scss';

const POLICIES_CONTRACARGOS_URL = 'https://fiscalpop.com/policies/#contracargos';
const POLICIES_DEVOLUCION_URL = 'https://fiscalpop.com/policies/#devolucion';
const CONTACT_EMAIL = 'contacto@fiscalpop.com';

export default function BlockedBilling() {
    return (
        <div id="Blocked">
            <div className="card">
                <h2>Esta cuenta se encuentra bloqueada</h2>
                <p>
                    Esta cuenta fue bloqueada debido a un contracargo, un reclamo de pago no reconocido, o
                    actividad sospechosa reportada por usted, su banco, o el proveedor de pago. 
                </p>
                <p>
                    El bloqueo se aplicó para su seguridad, con el fin de evitar pagos no reconocidos 
                    y actividades que puedan dañar a su empresa, y
                    permanecerá vigente hasta que la disputa sea retirada, resuelta por el emisor o procesador de pago,
                     o aclarada directamente con FiscalPOP.
                </p>
                <p>
                    Los contracargos y desconocimientos de pago se regulan conforme a nuestras {' '}
                    <a href={POLICIES_CONTRACARGOS_URL} target="_blank" rel="noopener noreferrer">
                        políticas de uso del servicio
                    </a>
                    .
                </p>
                <p>
                    Si el contracargo fue realizado por error, normalmente el proceso puede resolverse de forma más 
                    ágil contactando a su banco para retirar la disputa y comunicándose con nuestro equipo de soporte.
                    Si lo que requiere es solicitar una devolución, el procedimiento, requisitos y casos aplicables 
                    se detallan en nuestras {' '}
                    <a href={POLICIES_DEVOLUCION_URL} target="_blank" rel="noopener noreferrer">
                        políticas de devolución
                    </a>
                    .
                </p>
                <p className="_contact">
                    Para más información y aclaraciones, escríbanos a{' '}
                    <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> proporcionando una prueba
                    razonable de titularidad de la cuenta.
                </p>
            </div>
        </div>
    );
}
